<div #outsideModal class="modal">
  <div #modalBody class="modal-content">
    <div class="modal-header">Impression</div>
    <div class="modal-body" *ngIf="formGroup">
      <div class="checkbox-form">
        <label class="checkbox">
          <input [formGroup]="formGroup" [formControl]="formGroup.get('printCoordinatorHeader')" type="checkbox">
          <span class="checkMark"></span>
        </label>
        <div class="label" [ngClass]="{ 'is-checked': formGroup && formGroup.get('printCoordinatorHeader') && formGroup.get('printCoordinatorHeader').value === true }">À l'impression, insérer l'entête du médecin coordinateur</div>
      </div>
    
      <div class="checkbox-form">
        <label class="checkbox">
          <input [formGroup]="formGroup" [formControl]="formGroup.get('printInformations')" type="checkbox">
          <span class="checkMark"></span>
        </label>
        <div class="label" [ngClass]="{ 'is-checked': formGroup && formGroup.get('printInformations') && formGroup.get('printInformations').value === true }">Impression des informations</div>
      </div>
    </div>
    <div class="button-wrapper">
      <frg-button backgroundColor="var(--darkest-primary)" (activated)="closeModal()">Annuler</frg-button>
      <frg-button (activated)="closeModal(true)">Imprimer</frg-button>
    </div>
  </div>
</div>
<div class="modal-background"></div>